export default __webpack_public_path__ + "static/media/SELLOS_DISCOS_05.e6192a36.png";